import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoughnutChartDirective } from './doughnutChart.directive';

@NgModule({
  declarations: [DoughnutChartDirective],
  exports: [DoughnutChartDirective],
  imports: [CommonModule]
})
export class DoughnutChartModule {}
